import {
  ACCOUNTING_SERVICES_INDUSTRY_GROUP,
  ACTIVITIES_RELATED_TO_CREDIT_INTERMEDIATION_INDUSTRY_GROUP,
  ACTIVITIES_RELATED_TO_REAL_ESTATE_INDUSTRY_GROUP,
  ADVERTISING_SERVICES_INDUSTRY_GROUP,
  AEROSPACE_PRODUCT_MANUFACTURING_INDUSTRY_GROUP,
  AGENCIES_BROKERAGES_INDUSTRY_GROUP,
  AGRICULTURE_CONSTRUCTION_MANUFACTURING_INDUSTRY_GROUP,
  ALUMINA_AND_ALUMINUM_PRODUCTION_INDUSTRY_GROUP,
  AMUSEMENT_PARKS_INDUSTRY_GROUP,
  ANIMAL_FOOD_MANUFACTURING_INDUSTRY_GROUP,
  ANIMAL_SLAUGHTERING_INDUSTRY_GROUP,
  APPAREL_ACCESSORIES_INDUSTRY_GROUP,
  APPAREL_KNITTING_MILLS_INDUSTRY_GROUP,
  APPAREL_PIECE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
  AQUACULTURE_INDUSTRY_GROUP,
  ARCHITECTURAL_METALS_MANUFACTURING_INDUSTRY_GROUP,
  ARCHITECTURAL_SERVICES_INDUSTRY_GROUP,
  ARTISTS_AGENTS_AND_MANAGERS_INDUSTRY_GROUP,
  AUDIO_VIDEO_MANUFACTURING_INDUSTRY_GROUP,
  AUTO_DEALERS_INDUSTRY_GROUP,
  AUTOMOTIVE_LEASING_INDUSTRY_GROUP,
  AUTOMOTIVE_PARTS_INDUSTRY_GROUP,
  AUTOMOTIVE_REPAIR_INDUSTRY_GROUP,
  BAKERIES_MANUFACTURING_INDUSTRY_GROUP,
  BASIC_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP,
  BEER_WINE_LIQUOR_RETAILERS_INDUSTRY_GROUP,
  BEER_WINE_WHOLESALERS_INDUSTRY_GROUP,
  BEVERAGE_MANUFACTURING_INDUSTRY_GROUP,
  BOILERS_TANK_MANUFACTURING_INDUSTRY_GROUP,
  BOOK_RETAILERS_INDUSTRY_GROUP,
  BUILDING_EQUIPMENT_CONTRACTOR_INDUSTRY_GROUP,
  BUILDING_FINISHING_CONTRACTOR_INDUSTRY_GROUP,
  BUILDING_MATERIAL_AND_SUPPLIES_DEALERS_INDUSTRY_GROUP,
  BUSINESS_LABOR_POLITICAL_INDUSTRY_GROUP,
  BUSINESS_SCHOOLS_INDUSTRY_GROUP,
  BUSINESS_SUPPORT_SERVICES_INDUSTRY_GROUP,
  CATTLE_RANCHING_FARMING_INDUSTRY_GROUP,
  CEMENT_AND_CONCRETE_MANUFACTURING_INDUSTRY_GROUP,
  CHARTER_BUS_INDUSTRY_GROUP,
  CHEMICAL_AND_ALLIED_PRODUCTS_WHOLESALERS_INDUSTRY_GROUP,
  CHILD_CARE_SERVICES_INDUSTRY_GROUP,
  CLAY_PRODUCT_MANUFACTURING_INDUSTRY_GROUP,
  CLOTHING_RETAILERS_INDUSTRY_GROUP,
  COAL_MINING_INDUSTRY_GROUP,
  COATING_ENGRAVING_HEAT_TREATING_INDUSTRY_GROUP,
  COMMERCIAL_AND_SERVICE_INDUSTRY_MANUFACTURING_INDUSTRY_GROUP,
  COMMERCIAL_MACHINERY_INDUSTRY_GROUP,
  COMMERCIAL_REPAIR_AND_MAINTENANCE_INDUSTRY_GROUP,
  COMMODITY_CONTRACTS_INDUSTRY_GROUP,
  COMMODITY_EXCHANGES_INDUSTRY_GROUP,
  COMMUNICATION_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  COMPUTER_MANUFACTURING_INDUSTRY_GROUP,
  COMPUTER_SYSTEMS_DESIGN_SERVICES_INDUSTRY_GROUP,
  CONSUMER_GOODS_RENTAL_INDUSTRY_GROUP,
  CONVERTED_PAPER_MANUFACTURING_INDUSTRY_GROUP,
  COURIER_DELIVERY_INDUSTRY_GROUP,
  CRUDE_OIL_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP,
  CUT_AND_SEW_APPAREL_INDUSTRY_GROUP,
  CUTLERY_AND_HANDTOOL_MANUFACTURING_INDUSTRY_GROUP,
  DAIRY_MANUFACTURING_INDUSTRY_GROUP,
  DEATH_CARE_SERVICES_INDUSTRY_GROUP,
  DEEP_SEA_TRANSPORTATION_INDUSTRY_GROUP,
  DENTISTS_INDUSTRY_GROUP,
  DEPARTMENT_STORE_INDUSTRY_GROUP,
  DEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP,
  DESIGN_SERVICES_INDUSTRY_GROUP,
  DRINKING_PLACES_INDUSTRY_GROUP,
  DRUGS_WHOLESALERS_INDUSTRY_GROUP,
  EDUCATIONAL_SUPPORT_SERVICES_INDUSTRY_GROUP,
  ELECTRIC_LIGHTING_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  ELECTRIC_POWER_GENERATION_INDUSTRY_GROUP,
  ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  ELECTRONICS_REPAIR_INDUSTRY_GROUP,
  ELECTRONICS_RETAILERS_INDUSTRY_GROUP,
  ELEMENTARY_SCHOOLS_INDUSTRY_GROUP,
  EMPLOYMENTS_SERVICES_INDUSTRY_GROUP,
  ENGINE_TURBINE_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  FABRIC_MILLS_INDUSTRY_GROUP,
  FACILITIES_SUPPORT_SERVICES_INDUSTRY_GROUP,
  FARM_PRODUCT_WHOLESALERS_INDUSTRY_GROUP,
  FIBER_YARN_MILLS_INDUSTRY_GROUP,
  FISHING_INDUSTRY_GROUP,
  FLORISTS_INDUSTRY_GROUP,
  FOOTWEAR_MANUFACTURING_INDUSTRY_GROUP,
  FOREST_NURSERIES_INDUSTRY_GROUP,
  FORGING_AND_STAMPING_INDUSTRY_GROUP,
  FOUNDATION_CONTRACTOR_INDUSTRY_GROUP,
  FOUNDRIES_INDUSTRY_GROUP,
  FREIGHT_TRANSPORTATION_AGREEMENT_INDUSTRY_GROUP,
  FRUIT_AND_TREE_NUT_INDUSTRY_GROUP,
  FRUIT_PRESERVING_MANUFACTURING_INDUSTRY_GROUP,
  FUEL_DEALERS_INDUSTRY_GROUP,
  FURNITURE_AND_HONE_WHOLESALERS_INDUSTRY_GROUP,
  FURNITURE_RETAILERS_INDUSTRY_GROUP,
  GAMBLING_INDUSTRIES_INDUSTRY_GROUP,
  GASOLINE_STATIONS_INDUSTRY_GROUP,
  GENERAL_FREIGHT_TRUCKING_INDUSTRY_GROUP,
  GENERAL_MEDICAL_INDUSTRY_GROUP,
  GENERAL_RENTAL_CENTERS_INDUSTRY_GROUP,
  GLASS_MANUFACTURING_INDUSTRY_GROUP,
  GRAIN_AND_OILSEED_MILLING_INDUSTRY_GROUP,
  GRANTMAKING_INDUSTRY_GROUP,
  GREENHOUSE_NURSERY_AND_FLORICULTURE_INDUSTRY_GROUP,
  GROCERY_RETAILERS_INDUSTRY_GROUP,
  GROCERY_WHOLESALERS_INDUSTRY_GROUP,
  HARDWARE_AND_PLUMBING_WHOLESALERS_INDUSTRY_GROUP,
  HARDWARE_MANUFACTURING_INDUSTRY_GROUP,
  HIGHWAY_CONSTRUCTION_INDUSTRY_GROUP,
  HOD_AND_PIG_FARMING_INDUSTRY_GROUP,
  HOME_HEALTH_CARE_SERVICES_INDUSTRY_GROUP,
  HOUSEHOLD_APPLIANCE_MANUFACTURING_INDUSTRY_GROUP,
  HOUSEHOLD_APPLIANCES_WHOLESALERS_INDUSTRY_GROUP,
  HOUSEHOLD_MANUFACTURING_INDUSTRY_GROUP,
  HUNTING_AND_TRAPPING_INDUSTRY_GROUP,
  INDEPENDENT_ARTISTS_INDUSTRY_GROUP,
  INDIVIDUAL_AND_FAMILY_SERVICES_INDUSTRY_GROUP,
  INDUSTRIAL_MACHINERY_MANUFACTURING_INDUSTRY_GROUP,
  INLAND_WATER_TRANSPORTATION_INDUSTRY_GROUP,
  INSURANCE_CARRIER_INDUSTRY_GROUP,
  INSURANCE_FUNDS_INDUSTRY_GROUP,
  INTERURBAN_TRANSPORTATION_INDUSTRY_GROUP,
  INVESTIGATION_AND_SECURITY_SERVICES_INDUSTRY_GROUP,
  IRON_AND_STEEL_MILLS_INDUSTRY_GROUP,
  JEWELRY_RETAILERS_INDUSTRY_GROUP,
  JUNIOR_COLLEGES_INDUSTRY_GROUP,
  LAND_SUBDIVISION_INDUSTRY_GROUP,
  LAUNDRY_SERVICES_INDUSTRY_GROUP,
  LAWN_AND_GARDEN_EQUIPMENT_INDUSTRY_GROUP,
  LEATHER_AND_HIDE_TANNING_INDUSTRY_GROUP,
  LEGAL_SERVICES_INDUSTRY_GROUP,
  LESSORS_OF_REAL_ESTATE_INDUSTRY_GROUP,
  LIME_AND_GYPSUM_MANUFACTURING_INDUSTRY_GROUP,
  LOCAL_DELIVERY_INDUSTRY_GROUP,
  LOGGING_INDUSTRY_GROUP,
  LUMBER_WHOLESALERS_INDUSTRY_GROUP,
  MACHINE_SHOPS_MANUFACTURING_INDUSTRY_GROUP,
  MACHINERY_WHOLESALERS_INDUSTRY_GROUP,
  MANUFACTURING_AND_REPRODUCING_MAGNETIC_AND_OPTICAL_MEDIA_INDUSTRY_GROUP,
  MEDIA_STREAMING_INDUSTRY_GROUP,
  MEDICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  MEDICAL_LABS_INDUSTRY_GROUP,
  METAL_AND_MINERAL_WHOLESALERS_INDUSTRY_GROUP,
  METAL_ORE_MINING_INDUSTRY_GROUP,
  METALWORKING_MACHINERY_MANUFACTURING_INDUSTRY_GROUP,
  MISCELLANEOUS_DURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
  MISCELLANEOUS_NONDURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
  MOTION_PICTURE_INDUSTRY_GROUP,
  MOTOR_VEHICLE_MANUFACTURING_INDUSTRY_GROUP,
  MOTOR_VEHICLE_WHOLESALERS_INDUSTRY_GROUP,
  NATURAL_GAS_DISTRIBUTION_INDUSTRY_GROUP,
  NATURAL_GAS_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP,
  NAVIGATIONAL_INSTRUMENTS_INDUSTRY_GROUP,
  NEWSPAPER_INDUSTRY_GROUP,
  NONDEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP,
  NONFERROUS_METAL_PRODUCTION_INDUSTRY_GROUP,
  NONMETALLIC_MINERAL_MINING_INDUSTRY_GROUP,
  NONRESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP,
  NONSCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP,
  NURSING_CARE_FACILITIES_INDUSTRY_GROUP,
  OFFICE_ADMINISTRATIVE_SERVICES_INDUSTRY_GROUP,
  OFFICE_FURNITURE_MANUFACTURING_INDUSTRY_GROUP,
  OFFICE_SUPPLY_RETAILERS_INDUSTRY_GROUP,
  OFFICES_OF_REAL_ESTATE_INDUSTRY_GROUP,
  OILSEED_AND_GRAIN_INDUSTRY_GROUP,
  OTHER_AMBULATORY_HEALTH_CARE_INDUSTRY_GROUP,
  OTHER_AMUSEMENT_INDUSTRY_GROUP,
  OTHER_ANIMAL_PRODUCTION_INDUSTRY_GROUP,
  OTHER_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_CROP_FARMING_INDUSTRY_GROUP,
  OTHER_EATING_PLACES_INDUSTRY_GROUP,
  OTHER_ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_FABRICATED_TOOL_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_FINANCIAL_INVESTMENT_ACTIVITIES_INDUSTRY_GROUP,
  OTHER_FOOD_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_FUNDS_FUNDS_INDUSTRY_GROUP,
  OTHER_FURNITURE_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_GENERAL_PURPOSE_MACHINERY_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_HEALTH_PRACTITIONERS_INDUSTRY_GROUP,
  OTHER_HEAVY_CONSTRUCTION_INDUSTRY_GROUP,
  OTHER_LEATHER_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_MISCELLANEOUS_INDUSTRY_GROUP,
  OTHER_MISCELLANEOUS_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_MOTOR_DEALERS_INDUSTRY_GROUP,
  OTHER_NONMETALLIC_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_PERSONAL_SERVICES_INDUSTRY_GROUP,
  OTHER_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP,
  OTHER_RELIEF_SERVICES_INDUSTRY_GROUP,
  OTHER_RESIDENTIAL_CARE_INDUSTRY_GROUP,
  OTHER_SCHOOLS_INDUSTRY_GROUP,
  OTHER_SPECIALTY_TRADE_CONTRACTORS_INDUSTRY_GROUP,
  OTHER_SUPPORT_SERVICES_INDUSTRY_GROUP,
  OTHER_SUPPORT_TRANSPORTATION_INDUSTRY_GROUP,
  OTHER_TECHNICAL_SERVICES_INDUSTRY_GROUP,
  OTHER_TELECOMMUNICATIONS_INDUSTRY_GROUP,
  OTHER_TEXTILE_MILLS_INDUSTRY_GROUP,
  OTHER_TRANSIT_TRANSPORTATION_INDUSTRY_GROUP,
  OTHER_TRANSPORTATION_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_WOOD_PRODUCT_INDUSTRY_GROUP,
  OUTPATIENT_CARE_CENTERS_INDUSTRY_GROUP,
  PAINT_COATING_MANUFACTURING_INDUSTRY_GROUP,
  PAPER_AND_PRODUCT_WHOLESALERS_INDUSTRY_GROUP,
  PERFORMING_ARTS_COMPANIES_INDUSTRY_GROUP,
  PERSONAL_CARE_SERVICES_INDUSTRY_GROUP,
  PERSONAL_GOODS_REPAIR_INDUSTRY_GROUP,
  PESTICIDE_FERTILIZER_MANUFACTURING_INDUSTRY_GROUP,
  PETROLEUM_WHOLESALERS_INDUSTRY_GROUP,
  PHARMACEUTICAL_AND_MEDICINE_MANUFACTURING_INDUSTRY_GROUP,
  PHYSICIANS_INDUSTRY_GROUP,
  PLASTIC_MANUFACTURING_INDUSTRY_GROUP,
  POULTRY_AND_EGG_INDUSTRY_GROUP,
  PROF_AND_COMMERCIAL_EQUIPMENT_WHOLESALERS_INDUSTRY_GROUP,
  PROFESSIONAL_SCHOOLS_INDUSTRY_GROUP,
  PROMOTERS_OF_PERFORMING_ARTS_INDUSTRY_GROUP,
  PULP_PAPER_MILLS_INDUSTRY_GROUP,
  RADIO_AND_TELEVISION_INDUSTRY_GROUP,
  RAILROAD_MANUFACTURING_INDUSTRY_GROUP,
  RECREATIONAL_CAMPS_INDUSTRY_GROUP,
  RELIGIOUS_ORGANIZATIONS_INDUSTRY_GROUP,
  REMEDIATION_AND_OTHER_WASTE_MANAGEMENT_SERVICE_INDUSTRY_GROUP,
  RESERVATION_SERVICES_INDUSTRY_GROUP,
  RESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP,
  RESIDENTIAL_INTELLECTUAL_INDUSTRY_GROUP,
  RESIN_SYNTHETIC_RUBBER_MANUFACTURING_INDUSTRY_GROUP,
  RETIREMENT_COMMUNITIES_INDUSTRY_GROUP,
  RUBBER_MANUFACTURING_INDUSTRY_GROUP,
  SATELLITE_TELECOMMUNICATIONS_INDUSTRY_GROUP,
  SAWMILLS_AND_WOOD_PRESERVATION_INDUSTRY_GROUP,
  SCENIC_LAND_INDUSTRY_GROUP,
  SCENIC_OTHER_INDUSTRY_GROUP,
  SCENIC_WATER_INDUSTRY_GROUP,
  SCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP,
  SCHOOL_TRANSPORTATION_INDUSTRY_GROUP,
  SCIENTIFIC_RESEARCH_SERVICES_INDUSTRY_GROUP,
  SEAFOOD_PREPARATION_INDUSTRY_GROUP,
  SEMICONDUCTOR_MANUFACTURING_INDUSTRY_GROUP,
  SERVICES_TO_BUILDINGS_INDUSTRY_GROUP,
  SHEEP_AND_GOAT_INDUSTRY_GROUP,
  SHIP_AND_BOAT_BUILDING_INDUSTRY_GROUP,
  SHOE_RETAILERS_INDUSTRY_GROUP,
  SOAP_CLEANING_COMPOUND_MANUFACTURING_INDUSTRY_GROUP,
  SOCIAL_ADVOCACY_INDUSTRY_GROUP,
  SOCIAL_ORGANIZATIONS_INDUSTRY_GROUP,
  SOFTWARE_PUBLISHERS_INDUSTRY_GROUP,
  SOUND_INDUSTRY_GROUP,
  SPECIAL_FOOD_SERVICES_INDUSTRY_GROUP,
  SPECIALIZED_FREIGHT_TRUCKING_INDUSTRY_GROUP,
  SPECIALTY_FOOD_RETAILERS_INDUSTRY_GROUP,
  SPECIALTY_HOSPITALS__INDUSTRY_GROUP,
  SPECTATOR_SPORTS_INDUSTRY_GROUP,
  SPORTING_GOODS_RETAILERS_INDUSTRY_GROUP,
  SPRING_AND_WIRE_MANUFACTURING_INDUSTRY_GROUP,
  STEEL_PRODUCT_MANUFACTURING_INDUSTRY_GROUP,
  SUBSTANCE_ABUSE_HOSPITALS_INDUSTRY_GROUP,
  SUGAR_MANUFACTURING_INDUSTRY_GROUP,
  SUPPORT_ACTIVITIES_FOR_ANIMAL_INDUSTRY_GROUP,
  SUPPORT_ACTIVITIES_FOR_CROP_INDUSTRY_GROUP,
  SUPPORT_ACTIVITIES_FOR_FORESTRY_INDUSTRY_GROUP,
  SUPPORT_FOR_AIR_TRANSPORTATION_INDUSTRY_GROUP,
  SUPPORT_FOR_RAIL_TRANSPORTATION_INDUSTRY_GROUP,
  SUPPORT_FOR_ROAD_TRANSPORTATION_INDUSTRY_GROUP,
  SUPPORT_FOR_WATER_TRANSPORTATION_INDUSTRY_GROUP,
  TAXI_SERVICE_INDUSTRY_GROUP,
  TECHNICAL_CONSULTING_SERVICES_INDUSTRY_GROUP,
  TEXTILE_FURNISHING_MILLS_INDUSTRY_GROUP,
  TEXTILE_MILLS_INDUSTRY_GROUP,
  TIMBER_TRACK_OPERATIONS_INDUSTRY_GROUP,
  TOBACCO_MANUFACTURING_INDUSTRY_GROUP,
  TRADE_SCHOOLS_INDUSTRY_GROUP,
  TRAVELER_ACCOMMODATION_INDUSTRY_GROUP,
  URBAN_TRANSIT_SYSTEMS_INDUSTRY_GROUP,
  USED_MERCHANDISE_INDUSTRY_GROUP,
  UTILITY_SYSTEM_CONSTRUCTION_INDUSTRY_GROUP,
  VEGETABLE_AND_MELON_INDUSTRY_GROUP,
  VEHICLE_BODY_MANUFACTURING_INDUSTRY_GROUP,
  VEHICLE_PARTS_MANUFACTURING_INDUSTRY_GROUP,
  VENEER_PLYWOOD_INDUSTRY_GROUP,
  VENTILATION_HEATING_AIR_CONDITIONING_MANUFACTURING_INDUSTRY_GROUP,
  VOCATIONAL_REHABILITATION_SERVICES_INDUSTRY_GROUP,
  WAREHOUSE_CLUBS_RETAILERS_INDUSTRY_GROUP,
  WASTE_COLLECTION_INDUSTRY_GROUP,
  WASTE_DISPOSAL_INDUSTRY_GROUP,
  WIRED_TELECOMMUNICATIONS_INDUSTRY_GROUP,
  WORKERS_CAMPS_INDUSTRY_GROUP,
} from '../industryGroupOptions';
import { MANAGEMENT_OF_COMPANIES_SECTOR, SCIENTIFIC_SERVICES_SECTOR, UTILITIES_SECTOR } from '../industrySectorOptions';
import {
  ACCOMMODATION_SUB_SECTOR,
  ADMINISTRATION_OF_ECONOMIC_PROGRAMS_SUB_SECTOR,
  ADMINISTRATION_OF_ENVIRONMENTAL_QUALITY_SUB_SECTOR,
  ADMINISTRATION_OF_HOUSING_PROGRAMS_SUB_SECTOR,
  ADMINISTRATION_OF_HUMAN_RESOURCE_SUB_SECTOR,
  ADMINISTRATIVE_SERVICE_SUB_SECTOR,
  AGENTS_AND_BROKERS_SUB_SECTOR,
  AGRICULTURE_SUPPORT_ACTIVITIES_SUB_SECTOR,
  AIR_TRANSPORTATION_SUB_SECTOR,
  AMBULATORY_CARE_SUB_SECTOR,
  AMUSEMENT_INDUSTRY_SUB_SECTOR,
  ANIMAL_AND_AGRICULTURE_SUB_SECTOR,
  APPAREL_MANUFACTURING_SUB_SECTOR,
  BEVERAGE_AND_TOBACCO_MANUFACTURING_SUB_SECTOR,
  BROADCASTING_PROVIDER_SUB_SECTOR,
  BUILDING_CONSTRUCTION_SUB_SECTOR,
  BUILDING_MATERIAL_DEALERS_SUB_SECTOR,
  CHEMICAL_MANUFACTURING_SUB_SECTOR,
  CLOTHING_RETAILERS_SUB_SECTOR,
  COMPUTER_AND_ELECTRONIC_MANUFACTURING_SUB_SECTOR,
  COMPUTING_INFRASTRUCTURE_SUB_SECTOR,
  COURIERS_SUB_SECTOR,
  CREDIT_INTERMEDIATION_SUB_SECTOR,
  CROP_PRODUCTION_SUB_SECTOR,
  DURABLE_GOODS_SUB_SECTOR,
  EDUCATIONAL_SERVICES_SUB_SECTOR,
  ELECTRICAL_EQUIPMENT_MANUFACTURING_SUB_SECTOR,
  EXECUTIVE_LEGISLATIVE_SUB_SECTOR,
  FABRICATED_METAL_MANUFACTURING_SUB_SECTOR,
  FISHING_HUNTING_TRAPPING_SUB_SECTOR,
  FOOD_MANUFACTURING_SUB_SECTOR,
  FOOD_RETAILERS_SUB_SECTOR,
  FOOD_SERVICES_AND_DRINKING_PLACES_SUB_SECTOR,
  FORESTRY_AND_LOGGING_SUB_SECTOR,
  FUNDS_TRUSTS_SUB_SECTOR,
  FURNITURE_MANUFACTURING_SUB_SECTOR,
  FURNITURE_RETAILERS_SUB_SECTOR,
  GASOLINE_DEALERS_SUB_SECTOR,
  HEALTH_RETAILERS_SUB_SECTOR,
  HEAVY_AND_CIVIL_ENGINEERING_CONSTRUCTION_SUB_SECTOR,
  HOSPITALS_SUB_SECTOR,
  INSURANCE_CARRIERS_SUB_SECTOR,
  JUSTICE_PUBLIC_ORDER_SUB_SECTOR,
  LAUNDRY_SERVICE_SUB_SECTOR,
  LEATHER_AND_ALLIED_PRODUCT_MANUFACTURING_SUB_SECTOR,
  LESSORS_OF_NONFINACIAL_ASSETS_SUB_SECTOR,
  MACHINERY_MANUFACTURING_SUB_SECTOR,
  MERCHANDISE_RETAILERS_SUB_SECTOR,
  MINING_SUB_SECTOR,
  MINING_SUPPORT_ACTIVITIES_SUB_SECTOR,
  MISCELLANEOUS_MANUFACTURING_SUB_SECTOR,
  MONETARY_BANK_SUB_SECTOR,
  MOTION_PIC_INDUSTRIES_SUB_SECTOR,
  MOTOR_VEHICLE_AND_PARTS_DEALERS_SUB_SECTOR,
  MUSEUMS_SUB_SECTOR,
  NATIONAL_SECURITY_SUB_SECTOR,
  NONDURABLE_GOODS_SUB_SECTOR,
  NONMETALLIC_MINERAL_MANUFACTURING_SUB_SECTOR,
  NURSING_FACILITIES_SUB_SECTOR,
  OIL_GAS_EXTRACTION_SUB_SECTOR,
  PAPER_MANUFACTURING_SUB_SECTOR,
  PERFORMING_ARTS_SUB_SECTOR,
  PETROLEUM_AND_COAL_MANUFACTURING_SUB_SECTOR,
  PIPELINE_TRANSPORTATION_SUB_SECTOR,
  PLASTICS_AND_RUBBER_MANUFACTURING_SUB_SECTOR,
  POSTAL_SERVICE_SUB_SECTOR,
  PRIMARY_METAL_MANUFACTURING_SUB_SECTOR,
  PRINTING_MANUFACTURING_SUB_SECTOR,
  PRIVATE_HOUSEHOLDS_SUB_SECTOR,
  PUBLISHING_INDUSTRIES_SUB_SECTOR,
  RAIL_TRANSPORTATION_SUB_SECTOR,
  REAL_ESTATE_SUB_SECTOR,
  RELIGIOUS_SUB_SECTOR,
  RENTAL_AND_LEASING_SUB_SECTOR,
  REPAIR_AND_MAINTENANCE_SUB_SECTOR,
  SCENIC_TRANSPORTATION_SUB_SECTOR,
  SECURITIES_COMMODITY_SUB_SECTOR,
  SOCIAL_ASSISTANCE_SUB_SECTOR,
  SPACE_RESEARCH_SUB_SECTOR,
  SPECIALTY_TRADE_CONTRACTORS_SUB_SECTOR,
  SPORTING_GOODS_RETAILERS_SUB_SECTOR,
  SUPPORT_ACTIVITIES_FOR_TRANSPORTATION_SUB_SECTOR,
  TELECOMMUNICATION_SUB_SECTOR,
  TEXTILE_MILLS_SUB_SECTOR,
  TEXTILE_PRODUCT_MILLS_SUB_SECTOR,
  TRANSIT_TRANSPORTATION_SUB_SECTOR,
  TRANSPORTATION_EQUIPMENT_MANUFACTURING_SUB_SECTOR,
  TRUCK_TRANSPORTATION_SUB_SECTOR,
  WAREHOUSING_AND_STORAGE_SUB_SECTOR,
  WASTE_MANAGEMENT_SUB_SECTOR,
  WATER_TRANSPORTATION_SUB_SECTOR,
  WEB_SEARCH_PORTALS_SUB_SECTOR,
  WOOD_PRODUCT_MANUFACTURING_SUB_SECTOR,
} from '../industrySubSectorOptions';

export const INDUSTRY_GROUP_OPTIONS_DEU = {
  [CROP_PRODUCTION_SUB_SECTOR]: [
    { value: OILSEED_AND_GRAIN_INDUSTRY_GROUP, label: 'Ölsaaten- und Getreideanbau' },
    { value: VEGETABLE_AND_MELON_INDUSTRY_GROUP, label: 'Gemüse- und Melonenanbau' },
    { value: FRUIT_AND_TREE_NUT_INDUSTRY_GROUP, label: 'Obst- und Schalenobstanbau' },
    {
      value: GREENHOUSE_NURSERY_AND_FLORICULTURE_INDUSTRY_GROUP,
      label: 'Gewächshaus-, Baumschul- und Zierpflanzenproduktion',
    },
    { value: OTHER_CROP_FARMING_INDUSTRY_GROUP, label: 'Sonstiger Pflanzenbau' },
  ],
  [ANIMAL_AND_AGRICULTURE_SUB_SECTOR]: [
    { value: CATTLE_RANCHING_FARMING_INDUSTRY_GROUP, label: 'Rinderzucht und -haltung' },
    { value: HOD_AND_PIG_FARMING_INDUSTRY_GROUP, label: 'Schweinehaltung' },
    { value: POULTRY_AND_EGG_INDUSTRY_GROUP, label: 'Geflügel- und Eierproduktion' },
    { value: SHEEP_AND_GOAT_INDUSTRY_GROUP, label: 'Schaf- und Ziegenhaltung' },
    { value: AQUACULTURE_INDUSTRY_GROUP, label: 'Aquakultur' },
    { value: OTHER_ANIMAL_PRODUCTION_INDUSTRY_GROUP, label: 'Sonstige Tierproduktion' },
  ],
  [FORESTRY_AND_LOGGING_SUB_SECTOR]: [
    { value: TIMBER_TRACK_OPERATIONS_INDUSTRY_GROUP, label: 'Bewirtschaftung von Forstflächen' },
    {
      value: FOREST_NURSERIES_INDUSTRY_GROUP,
      label: 'Forstbaumschulen und Sammeln von Waldprodukten',
    },
    { value: LOGGING_INDUSTRY_GROUP, label: 'Holzeinschlag' },
  ],
  [FISHING_HUNTING_TRAPPING_SUB_SECTOR]: [
    { value: FISHING_INDUSTRY_GROUP, label: 'Fischerei' },
    { value: HUNTING_AND_TRAPPING_INDUSTRY_GROUP, label: 'Jagd und Fallenstellen' },
  ],
  [AGRICULTURE_SUPPORT_ACTIVITIES_SUB_SECTOR]: [
    {
      value: SUPPORT_ACTIVITIES_FOR_CROP_INDUSTRY_GROUP,
      label: 'Unterstützende Tätigkeiten für Landwirtschaft und Forstwirtschaft',
    },
    {
      value: SUPPORT_ACTIVITIES_FOR_ANIMAL_INDUSTRY_GROUP,
      label: 'Unterstützende Tätigkeiten für die Tierproduktion',
    },
    {
      value: SUPPORT_ACTIVITIES_FOR_FORESTRY_INDUSTRY_GROUP,
      label: 'Unterstützende Tätigkeiten für die Forstwirtschaft',
    },
  ],
  [OIL_GAS_EXTRACTION_SUB_SECTOR]: [],
  [MINING_SUB_SECTOR]: [
    { value: COAL_MINING_INDUSTRY_GROUP, label: 'Kohlenbergbau' },
    { value: METAL_ORE_MINING_INDUSTRY_GROUP, label: 'Erzbergbau' },
    {
      value: NONMETALLIC_MINERAL_MINING_INDUSTRY_GROUP,
      label: 'Gewinnung nichtmetallischer Mineralien und Steinbrüche',
    },
  ],
  [MINING_SUPPORT_ACTIVITIES_SUB_SECTOR]: [],
  [UTILITIES_SECTOR]: [
    {
      value: ELECTRIC_POWER_GENERATION_INDUSTRY_GROUP,
      label: 'Elektrizitätserzeugung, -übertragung und -verteilung',
    },
    {
      value: NATURAL_GAS_DISTRIBUTION_INDUSTRY_GROUP,
      label: 'Verteilung von Erdgas',
    },
  ],
  [BUILDING_CONSTRUCTION_SUB_SECTOR]: [
    {
      value: RESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP,
      label: 'Wohngebäudebau',
    },
    {
      value: NONRESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP,
      label: 'Nichtwohngebäudebau',
    },
  ],
  [HEAVY_AND_CIVIL_ENGINEERING_CONSTRUCTION_SUB_SECTOR]: [
    {
      value: UTILITY_SYSTEM_CONSTRUCTION_INDUSTRY_GROUP,
      label: 'Leitungs- und Versorgungsleitungsbau',
    },
    { value: LAND_SUBDIVISION_INDUSTRY_GROUP, label: 'Erschließung und Parzellierung von Bauland' },
    {
      value: HIGHWAY_CONSTRUCTION_INDUSTRY_GROUP,
      label: 'Bau von Straßen, Autobahnen und Brücken',
    },
    {
      value: OTHER_HEAVY_CONSTRUCTION_INDUSTRY_GROUP,
      label: 'Sonstiger Hoch- und Tiefbau',
    },
  ],
  [SPECIALTY_TRADE_CONTRACTORS_SUB_SECTOR]: [
    {
      value: FOUNDATION_CONTRACTOR_INDUSTRY_GROUP,
      label: 'Bau von Fundamenten, Tragwerken und Gebäudeaußenhüllen',
    },
    {
      value: BUILDING_EQUIPMENT_CONTRACTOR_INDUSTRY_GROUP,
      label: 'Gebäudetechnik- und Ausrüstungsinstallateure',
    },
    {
      value: BUILDING_FINISHING_CONTRACTOR_INDUSTRY_GROUP,
      label: 'Ausbaugewerbe (Innenausbau und Gebäudefertigstellung)',
    },
    {
      value: OTHER_SPECIALTY_TRADE_CONTRACTORS_INDUSTRY_GROUP,
      label: 'Sonstige Ausbaugewerke',
    },
  ],
  [FOOD_MANUFACTURING_SUB_SECTOR]: [
    {
      value: ANIMAL_FOOD_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Futtermitteln',
    },
    {
      value: GRAIN_AND_OILSEED_MILLING_INDUSTRY_GROUP,
      label: 'Mahlen von Getreide und Ölsaaten',
    },
    {
      value: SUGAR_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Zucker und Süßwaren',
    },
    {
      value: FRUIT_PRESERVING_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung haltbarer Obst- und Gemüseerzeugnisse und Speziallebensmittel',
    },
    {
      value: DAIRY_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Milcherzeugnissen',
    },
    {
      value: ANIMAL_SLAUGHTERING_INDUSTRY_GROUP,
      label: 'Schlachtung und Fleischverarbeitung',
    },
    {
      value: SEAFOOD_PREPARATION_INDUSTRY_GROUP,
      label: 'Herstellung und Verpackung von Fisch- und Meeresfrüchteerzeugnissen',
    },
    {
      value: BAKERIES_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Backwaren und Tortillas',
    },
    {
      value: OTHER_FOOD_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Sonstige Nahrungsmittelherstellung',
    },
  ],
  [BEVERAGE_AND_TOBACCO_MANUFACTURING_SUB_SECTOR]: [
    { value: BEVERAGE_MANUFACTURING_INDUSTRY_GROUP, label: 'Getränkeherstellung' },
    { value: TOBACCO_MANUFACTURING_INDUSTRY_GROUP, label: 'Tabakverarbeitung' },
  ],
  [TEXTILE_MILLS_SUB_SECTOR]: [
    {
      value: FIBER_YARN_MILLS_INDUSTRY_GROUP,
      label: 'Spinnereien für Fasern, Garn und Fäden',
    },
    { value: FABRIC_MILLS_INDUSTRY_GROUP, label: 'Webereien' },
    {
      value: TEXTILE_MILLS_INDUSTRY_GROUP,
      label: 'Ausrüstung und Beschichtung von Textilien und Stoffen',
    },
  ],
  [TEXTILE_PRODUCT_MILLS_SUB_SECTOR]: [
    {
      value: TEXTILE_FURNISHING_MILLS_INDUSTRY_GROUP,
      label: 'Herstellung von Heimtextilien',
    },
    {
      value: OTHER_TEXTILE_MILLS_INDUSTRY_GROUP,
      label: 'Sonstige Textilwarenherstellung',
    },
  ],
  [APPAREL_MANUFACTURING_SUB_SECTOR]: [
    {
      value: APPAREL_KNITTING_MILLS_INDUSTRY_GROUP,
      label: 'Strickwarenherstellung (Bekleidung)',
    },
    {
      value: CUT_AND_SEW_APPAREL_INDUSTRY_GROUP,
      label: 'Zuschneiden und Nähen von Bekleidung',
    },
    {
      value: APPAREL_ACCESSORIES_INDUSTRY_GROUP,
      label: 'Herstellung von Bekleidungsaccessoires und sonstiger Bekleidung',
    },
  ],
  [LEATHER_AND_ALLIED_PRODUCT_MANUFACTURING_SUB_SECTOR]: [
    {
      value: LEATHER_AND_HIDE_TANNING_INDUSTRY_GROUP,
      label: 'Gerben und Zurichten von Häuten und Leder',
    },
    { value: FOOTWEAR_MANUFACTURING_INDUSTRY_GROUP, label: 'Schuhherstellung' },
    {
      value: OTHER_LEATHER_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung sonstiger Lederwaren und ähnlicher Erzeugnisse',
    },
  ],
  [WOOD_PRODUCT_MANUFACTURING_SUB_SECTOR]: [
    {
      value: SAWMILLS_AND_WOOD_PRESERVATION_INDUSTRY_GROUP,
      label: 'Sägewerke und Holzimprägnierung',
    },
    {
      value: VENEER_PLYWOOD_INDUSTRY_GROUP,
      label: 'Herstellung von Furnieren, Sperrholz und Holzwerkstoffen',
    },
    {
      value: OTHER_WOOD_PRODUCT_INDUSTRY_GROUP,
      label: 'Sonstige Holzwarenherstellung',
    },
  ],
  [PAPER_MANUFACTURING_SUB_SECTOR]: [
    {
      value: PULP_PAPER_MILLS_INDUSTRY_GROUP,
      label: 'Herstellung von Zellstoff, Papier und Pappe',
    },
    {
      value: CONVERTED_PAPER_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Papierwaren',
    },
  ],
  [PRINTING_MANUFACTURING_SUB_SECTOR]: [],
  [PETROLEUM_AND_COAL_MANUFACTURING_SUB_SECTOR]: [],
  [CHEMICAL_MANUFACTURING_SUB_SECTOR]: [
    {
      value: BASIC_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Grundchemikalienherstellung',
    },
    {
      value: RESIN_SYNTHETIC_RUBBER_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Harzen, Synthesekautschuk sowie künstlichen und synthetischen Fasern und Filamenten',
    },
    {
      value: PESTICIDE_FERTILIZER_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Pflanzenschutz-, Düngemitteln und sonstigen agrochemischen Erzeugnissen',
    },
    {
      value: PHARMACEUTICAL_AND_MEDICINE_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von pharmazeutischen Erzeugnissen',
    },
    {
      value: PAINT_COATING_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Farben, Lacken und Klebstoffen',
    },
    {
      value: SOAP_CLEANING_COMPOUND_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Seifen, Reinigungs- und Körperpflegemitteln',
    },
    {
      value: OTHER_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung sonstiger chemischer Erzeugnisse und Zubereitungen',
    },
  ],
  [PLASTICS_AND_RUBBER_MANUFACTURING_SUB_SECTOR]: [
    {
      value: PLASTIC_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Kunststoffwaren',
    },
    {
      value: RUBBER_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Gummiwaren',
    },
  ],
  [NONMETALLIC_MINERAL_MANUFACTURING_SUB_SECTOR]: [
    {
      value: CLAY_PRODUCT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von keramischen Erzeugnissen und feuerfesten Produkten',
    },
    {
      value: GLASS_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Glas und Glaswaren',
    },
    {
      value: CEMENT_AND_CONCRETE_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Zement- und Betonwaren',
    },
    {
      value: LIME_AND_GYPSUM_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Kalk- und Gipsprodukten',
    },
    {
      value: OTHER_NONMETALLIC_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung sonstiger nichtmetallischer Mineralerzeugnisse',
    },
  ],
  [PRIMARY_METAL_MANUFACTURING_SUB_SECTOR]: [
    {
      value: IRON_AND_STEEL_MILLS_INDUSTRY_GROUP,
      label: 'Herstellung von Roheisen, Stahl und Ferrolegierungen',
    },
    {
      value: STEEL_PRODUCT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Stahlerzeugnissen aus zugekauftem Stahl',
    },
    {
      value: ALUMINA_AND_ALUMINUM_PRODUCTION_INDUSTRY_GROUP,
      label: 'Herstellung und Verarbeitung von Aluminiumoxid und Aluminium',
    },
    {
      value: NONFERROUS_METAL_PRODUCTION_INDUSTRY_GROUP,
      label: 'Herstellung und Verarbeitung nichteisenhaltiger Metalle (ohne Aluminium)',
    },
    { value: FOUNDRIES_INDUSTRY_GROUP, label: 'Gießereien' },
  ],
  [FABRICATED_METAL_MANUFACTURING_SUB_SECTOR]: [
    {
      value: FORGING_AND_STAMPING_INDUSTRY_GROUP,
      label: 'Gesenk- und Freiformschmieden sowie Stanzen',
    },
    {
      value: CUTLERY_AND_HANDTOOL_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Schneidwaren und Handwerkzeugen',
    },
    {
      value: ARCHITECTURAL_METALS_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Bau- und Konstruktionsmetallerzeugnissen',
    },
    {
      value: BOILERS_TANK_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Kesseln, Behältern und Frachtcontainern',
    },
    { value: HARDWARE_MANUFACTURING_INDUSTRY_GROUP, label: 'Beschlagherstellung' },
    {
      value: SPRING_AND_WIRE_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Federn und Drahterzeugnissen',
    },
    {
      value: MACHINE_SHOPS_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Zerspanungsbetriebe sowie Herstellung von Drehteilen, Schrauben, Muttern und Bolzen',
    },
    {
      value: COATING_ENGRAVING_HEAT_TREATING_INDUSTRY_GROUP,
      label: 'Beschichten, Gravieren, Wärmebehandlung und ähnliche Tätigkeiten',
    },
    {
      value: OTHER_FABRICATED_TOOL_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung sonstiger Metallerzeugnisse',
    },
  ],
  [MACHINERY_MANUFACTURING_SUB_SECTOR]: [
    {
      value: AGRICULTURE_CONSTRUCTION_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Landwirtschafts-, Bau- und Bergbaumaschinen',
    },
    {
      value: INDUSTRIAL_MACHINERY_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Industriemaschinen',
    },
    {
      value: COMMERCIAL_AND_SERVICE_INDUSTRY_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Maschinen für Handel und Dienstleistungsgewerbe',
    },
    {
      value: VENTILATION_HEATING_AIR_CONDITIONING_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Lüftungs-, Heizungs-, Klimaanlagen- und gewerblicher Kälteanlagentechnik',
    },
    {
      value: METALWORKING_MACHINERY_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Werkzeugmaschinen für die Metallbearbeitung',
    },
    {
      value: ENGINE_TURBINE_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Motoren, Turbinen und Antriebstechnik',
    },
    {
      value: OTHER_GENERAL_PURPOSE_MACHINERY_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung sonstiger Maschinen für allgemeine Zwecke',
    },
  ],
  [COMPUTER_AND_ELECTRONIC_MANUFACTURING_SUB_SECTOR]: [
    {
      value: COMPUTER_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Datenverarbeitungsgeräten und peripheren Geräten',
    },
    {
      value: COMMUNICATION_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Kommunikationsausrüstung',
    },
    {
      value: AUDIO_VIDEO_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Audio- und Videoapparaten',
    },
    {
      value: SEMICONDUCTOR_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Halbleitern und sonstigen elektronischen Bauelementen',
    },
    {
      value: NAVIGATIONAL_INSTRUMENTS_INDUSTRY_GROUP,
      label: 'Herstellung von Mess-, Navigations-, medizinischen und Kontrollinstrumenten',
    },
    {
      value: MANUFACTURING_AND_REPRODUCING_MAGNETIC_AND_OPTICAL_MEDIA_INDUSTRY_GROUP,
      label: 'Herstellung und Vervielfältigung von magnetischen und optischen Datenträgern',
    },
  ],
  [ELECTRICAL_EQUIPMENT_MANUFACTURING_SUB_SECTOR]: [
    {
      value: ELECTRIC_LIGHTING_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von elektrischen Beleuchtungsgeräten',
    },
    {
      value: HOUSEHOLD_APPLIANCE_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Haushaltsgeräten',
    },
    {
      value: ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von elektrischen Ausrüstungen',
    },
    {
      value: OTHER_ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung sonstiger elektrischer Ausrüstungen und Komponenten',
    },
  ],
  [TRANSPORTATION_EQUIPMENT_MANUFACTURING_SUB_SECTOR]: [
    {
      value: MOTOR_VEHICLE_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Kraftwagen',
    },
    {
      value: VEHICLE_BODY_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Karosserien und Anhängern für Kraftfahrzeuge',
    },
    {
      value: VEHICLE_PARTS_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Kraftfahrzeugteilen und -zubehör',
    },
    {
      value: AEROSPACE_PRODUCT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Luft- und Raumfahrterzeugnissen und -teilen',
    },
    {
      value: RAILROAD_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Schienenfahrzeugen',
    },
    {
      value: SHIP_AND_BOAT_BUILDING_INDUSTRY_GROUP,
      label: 'Schiffs- und Bootsbau',
    },
    {
      value: OTHER_TRANSPORTATION_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung sonstiger Verkehrsmittel',
    },
  ],
  [FURNITURE_MANUFACTURING_SUB_SECTOR]: [
    {
      value: HOUSEHOLD_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Möbeln für Haushalte und Institutionen sowie Küchenmöbeln',
    },
    {
      value: OFFICE_FURNITURE_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von Büromöbeln (einschließlich Einbauten)',
    },
    {
      value: OTHER_FURNITURE_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung sonstiger möbelbezogener Erzeugnisse',
    },
  ],
  [MISCELLANEOUS_MANUFACTURING_SUB_SECTOR]: [
    {
      value: MEDICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Herstellung von medizinischen Geräten und Bedarfsartikeln',
    },
    {
      value: OTHER_MISCELLANEOUS_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Sonstige Warenherstellung',
    },
  ],
  [DURABLE_GOODS_SUB_SECTOR]: [
    {
      value: MOTOR_VEHICLE_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Großhandel mit Kraftfahrzeugen sowie Kraftfahrzeugteilen und -zubehör',
    },
    {
      value: FURNITURE_AND_HONE_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Großhandel mit Möbeln und Einrichtungsgegenständen',
    },
    {
      value: LUMBER_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Großhandel mit Holz und anderen Baumaterialien',
    },
    {
      value: PROF_AND_COMMERCIAL_EQUIPMENT_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Großhandel mit Berufs- und gewerblicher Ausrüstung und Bedarf',
    },
    {
      value: METAL_AND_MINERAL_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Großhandel mit Metallen und Mineralien (ohne Erdöl)',
    },
    {
      value: HOUSEHOLD_APPLIANCES_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Großhandel mit Haushaltsgeräten sowie elektrischen und elektronischen Erzeugnissen',
    },
    {
      value: HARDWARE_AND_PLUMBING_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Großhandel mit Eisenwaren sowie Installations- und Heizungsbedarf',
    },
    {
      value: MACHINERY_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Großhandel mit Maschinen, Ausrüstungen und Zubehör',
    },
    {
      value: MISCELLANEOUS_DURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Großhandel mit sonstigen langlebigen Gütern',
    },
  ],
  [NONDURABLE_GOODS_SUB_SECTOR]: [
    {
      value: PAPER_AND_PRODUCT_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Großhandel mit Papier und Papierwaren',
    },
    {
      value: DRUGS_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Großhandel mit pharmazeutischen Erzeugnissen und Drogeriewaren',
    },
    {
      value: APPAREL_PIECE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Großhandel mit Bekleidung, Textilwaren und Kurzwaren',
    },
    {
      value: GROCERY_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Großhandel mit Nahrungsmitteln und verwandten Erzeugnissen',
    },
    {
      value: FARM_PRODUCT_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Großhandel mit landwirtschaftlichen Rohstoffen',
    },
    {
      value: CHEMICAL_AND_ALLIED_PRODUCTS_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Großhandel mit chemischen Erzeugnissen und verwandten Produkten',
    },
    {
      value: PETROLEUM_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Großhandel mit Erdöl und Erdölerzeugnissen',
    },
    {
      value: BEER_WINE_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Großhandel mit Bier, Wein und Spirituosen',
    },
    {
      value: MISCELLANEOUS_NONDURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Großhandel mit sonstigen kurzlebigen Gütern',
    },
  ],
  [AGENTS_AND_BROKERS_SUB_SECTOR]: [],
  [MOTOR_VEHICLE_AND_PARTS_DEALERS_SUB_SECTOR]: [
    { value: AUTO_DEALERS_INDUSTRY_GROUP, label: 'Kraftfahrzeughändler' },
    {
      value: OTHER_MOTOR_DEALERS_INDUSTRY_GROUP,
      label: 'Händler für sonstige Kraftfahrzeuge',
    },
    {
      value: AUTOMOTIVE_PARTS_INDUSTRY_GROUP,
      label: 'Einzelhandel mit Kraftfahrzeugteilen, -zubehör und Reifen',
    },
  ],

  [BUILDING_MATERIAL_DEALERS_SUB_SECTOR]: [
    {
      value: BUILDING_MATERIAL_AND_SUPPLIES_DEALERS_INDUSTRY_GROUP,
      label: 'Einzelhandel mit Baustoffen und Baumaterial',
    },
    {
      value: LAWN_AND_GARDEN_EQUIPMENT_INDUSTRY_GROUP,
      label: 'Einzelhandel mit Rasen- und Gartengeräten und -bedarf',
    },
  ],
  [FOOD_RETAILERS_SUB_SECTOR]: [
    {
      value: GROCERY_RETAILERS_INDUSTRY_GROUP,
      label: 'Lebensmittel- und Convenience-Einzelhändler',
    },
    {
      value: SPECIALTY_FOOD_RETAILERS_INDUSTRY_GROUP,
      label: 'Facheinzelhandel mit Lebensmitteln',
    },
    {
      value: BEER_WINE_LIQUOR_RETAILERS_INDUSTRY_GROUP,
      label: 'Einzelhandel mit Bier, Wein und Spirituosen',
    },
  ],
  [FURNITURE_RETAILERS_SUB_SECTOR]: [
    {
      value: FURNITURE_RETAILERS_INDUSTRY_GROUP,
      label: 'Möbel- und Wohnaccessoire-Einzelhändler',
    },
    {
      value: ELECTRONICS_RETAILERS_INDUSTRY_GROUP,
      label: 'Elektro- und Haushaltsgeräteeinzelhändler',
    },
  ],
  [MERCHANDISE_RETAILERS_SUB_SECTOR]: [
    {
      value: DEPARTMENT_STORE_INDUSTRY_GROUP,
      label: 'Warenhäuser',
    },
    {
      value: WAREHOUSE_CLUBS_RETAILERS_INDUSTRY_GROUP,
      label: 'Mitgliedermärkte, Supercenter und sonstiger Einzelhandel für Waren des allgemeinen Bedarfs',
    },
  ],
  [HEALTH_RETAILERS_SUB_SECTOR]: [],
  [GASOLINE_DEALERS_SUB_SECTOR]: [
    {
      value: GASOLINE_STATIONS_INDUSTRY_GROUP,
      label: 'Tankstellen',
    },
    {
      value: FUEL_DEALERS_INDUSTRY_GROUP,
      label: 'Brenn- und Kraftstoffhändler',
    },
  ],
  [CLOTHING_RETAILERS_SUB_SECTOR]: [
    {
      value: CLOTHING_RETAILERS_INDUSTRY_GROUP,
      label: 'Bekleidungs- und Zubehör-Einzelhändler',
    },
    {
      value: SHOE_RETAILERS_INDUSTRY_GROUP,
      label: 'Schuh-Einzelhändler',
    },
    {
      value: JEWELRY_RETAILERS_INDUSTRY_GROUP,
      label: 'Einzelhandel mit Schmuck, Reisegepäck und Lederwaren',
    },
  ],
  [SPORTING_GOODS_RETAILERS_SUB_SECTOR]: [
    {
      value: SPORTING_GOODS_RETAILERS_INDUSTRY_GROUP,
      label: 'Einzelhandel mit Sportartikeln, Hobbybedarf und Musikinstrumenten',
    },
    {
      value: BOOK_RETAILERS_INDUSTRY_GROUP,
      label: 'Buch- und Zeitschrifteneinzelhändler',
    },
    {
      value: FLORISTS_INDUSTRY_GROUP,
      label: 'Blumenfachgeschäfte',
    },
    {
      value: OFFICE_SUPPLY_RETAILERS_INDUSTRY_GROUP,
      label: 'Einzelhandel mit Bürobedarf, Schreibwaren und Geschenkartikeln',
    },
    {
      value: USED_MERCHANDISE_INDUSTRY_GROUP,
      label: 'Einzelhandel mit Gebrauchtwaren',
    },
    {
      value: OTHER_MISCELLANEOUS_INDUSTRY_GROUP,
      label: 'Sonstiger übriger Einzelhandel',
    },
  ],
  [AIR_TRANSPORTATION_SUB_SECTOR]: [
    {
      value: SCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Planmäßiger Luftverkehr',
    },
    {
      value: NONSCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Nichtplanmäßiger Luftverkehr',
    },
  ],
  [RAIL_TRANSPORTATION_SUB_SECTOR]: [],
  [WATER_TRANSPORTATION_SUB_SECTOR]: [
    {
      value: DEEP_SEA_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Hochsee-, Küsten- und Großer-Seen-Schifffahrt',
    },
    {
      value: INLAND_WATER_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Binnenschifffahrt',
    },
  ],
  [TRUCK_TRANSPORTATION_SUB_SECTOR]: [
    {
      value: GENERAL_FREIGHT_TRUCKING_INDUSTRY_GROUP,
      label: 'Straßengüterverkehr (allgemeine Fracht)',
    },
    {
      value: SPECIALIZED_FREIGHT_TRUCKING_INDUSTRY_GROUP,
      label: 'Straßengüterverkehr (spezialisierte Fracht)',
    },
  ],
  [TRANSIT_TRANSPORTATION_SUB_SECTOR]: [
    {
      value: URBAN_TRANSIT_SYSTEMS_INDUSTRY_GROUP,
      label: 'Städtische Verkehrssysteme',
    },
    {
      value: INTERURBAN_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Linienbusverkehr im Überland- und ländlichen Bereich',
    },
    {
      value: TAXI_SERVICE_INDUSTRY_GROUP,
      label: 'Taxi- und Limousinenservice',
    },
    {
      value: SCHOOL_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Schüler- und Arbeitnehmerbeförderung mit Bussen',
    },
    {
      value: CHARTER_BUS_INDUSTRY_GROUP,
      label: 'Reise- und Charterbusverkehr',
    },
    {
      value: OTHER_TRANSIT_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Sonstiger Nah- und Straßenpersonenverkehr',
    },
  ],
  [PIPELINE_TRANSPORTATION_SUB_SECTOR]: [
    {
      value: CRUDE_OIL_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Rohrfernleitungen für Rohöl',
    },
    {
      value: NATURAL_GAS_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Rohrfernleitungen für Erdgas',
    },
    {
      value: OTHER_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Sonstiger Rohrfernleitungsverkehr',
    },
  ],
  [SCENIC_TRANSPORTATION_SUB_SECTOR]: [
    {
      value: SCENIC_LAND_INDUSTRY_GROUP,
      label: 'Ausflugs- und Sightseeing-Verkehr zu Land',
    },
    {
      value: SCENIC_WATER_INDUSTRY_GROUP,
      label: 'Ausflugs- und Sightseeing-Schifffahrt',
    },
    {
      value: SCENIC_OTHER_INDUSTRY_GROUP,
      label: 'Sonstiger Ausflugs- und Sightseeing-Verkehr',
    },
  ],
  [SUPPORT_ACTIVITIES_FOR_TRANSPORTATION_SUB_SECTOR]: [
    {
      value: SUPPORT_FOR_AIR_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Mit dem Luftverkehr verbundene Dienstleistungen',
    },
    {
      value: SUPPORT_FOR_RAIL_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Mit dem Schienenverkehr verbundene Dienstleistungen',
    },
    {
      value: SUPPORT_FOR_WATER_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Mit der Schifffahrt verbundene Dienstleistungen',
    },
    {
      value: SUPPORT_FOR_ROAD_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Mit dem Straßenverkehr verbundene Dienstleistungen',
    },
    {
      value: FREIGHT_TRANSPORTATION_AGREEMENT_INDUSTRY_GROUP,
      label: 'Organisation des Gütertransports',
    },
    {
      value: OTHER_SUPPORT_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Sonstige mit dem Verkehr verbundene Unterstützungsdienste',
    },
  ],
  [POSTAL_SERVICE_SUB_SECTOR]: [],
  [COURIERS_SUB_SECTOR]: [
    {
      value: COURIER_DELIVERY_INDUSTRY_GROUP,
      label: 'Kurier-, Express- und Paketdienste',
    },
    {
      value: LOCAL_DELIVERY_INDUSTRY_GROUP,
      label: 'Botendienste und lokale Zustellung',
    },
  ],
  [WAREHOUSING_AND_STORAGE_SUB_SECTOR]: [],
  [MOTION_PIC_INDUSTRIES_SUB_SECTOR]: [
    {
      value: MOTION_PICTURE_INDUSTRY_GROUP,
      label: 'Film- und Videowirtschaft',
    },
    {
      value: SOUND_INDUSTRY_GROUP,
      label: 'Tonträgerindustrie',
    },
  ],
  [PUBLISHING_INDUSTRIES_SUB_SECTOR]: [
    {
      value: NEWSPAPER_INDUSTRY_GROUP,
      label: 'Verlage für Zeitungen, Zeitschriften, Bücher und Verzeichnisse',
    },
    {
      value: SOFTWARE_PUBLISHERS_INDUSTRY_GROUP,
      label: 'Softwareverlage',
    },
  ],
  [BROADCASTING_PROVIDER_SUB_SECTOR]: [
    {
      value: RADIO_AND_TELEVISION_INDUSTRY_GROUP,
      label: 'Rundfunk- und Fernsehanstalten',
    },
    {
      value: MEDIA_STREAMING_INDUSTRY_GROUP,
      label: 'Mediendienste für Streaming, soziale Netzwerke und sonstige Mediennetzwerke und Inhalteanbieter',
    },
  ],
  [TELECOMMUNICATION_SUB_SECTOR]: [
    {
      value: WIRED_TELECOMMUNICATIONS_INDUSTRY_GROUP,
      label: 'Kabelgebundene und drahtlose Telekommunikation (ohne Satellit)',
    },
    {
      value: SATELLITE_TELECOMMUNICATIONS_INDUSTRY_GROUP,
      label: 'Satelliten-Telekommunikation',
    },
    {
      value: OTHER_TELECOMMUNICATIONS_INDUSTRY_GROUP,
      label: 'Sonstige Telekommunikationsdienste',
    },
  ],
  [COMPUTING_INFRASTRUCTURE_SUB_SECTOR]: [],
  [WEB_SEARCH_PORTALS_SUB_SECTOR]: [],
  [MONETARY_BANK_SUB_SECTOR]: [],
  [CREDIT_INTERMEDIATION_SUB_SECTOR]: [
    {
      value: DEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP,
      label: 'Kreditinstitute mit Einlagengeschäft',
    },
    {
      value: NONDEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP,
      label: 'Kreditvermittlung ohne Einlagengeschäft',
    },
    {
      value: ACTIVITIES_RELATED_TO_CREDIT_INTERMEDIATION_INDUSTRY_GROUP,
      label: 'Mit der Kreditvermittlung verbundene Tätigkeiten',
    },
  ],
  [SECURITIES_COMMODITY_SUB_SECTOR]: [
    {
      value: COMMODITY_CONTRACTS_INDUSTRY_GROUP,
      label: 'Wertpapier- und Warenterminhandel sowie Vermittlung',
    },
    {
      value: COMMODITY_EXCHANGES_INDUSTRY_GROUP,
      label: 'Wertpapier- und Warenterminbörsen',
    },
    {
      value: OTHER_FINANCIAL_INVESTMENT_ACTIVITIES_INDUSTRY_GROUP,
      label: 'Sonstige Finanzanlageaktivitäten',
    },
  ],
  [INSURANCE_CARRIERS_SUB_SECTOR]: [
    {
      value: INSURANCE_CARRIER_INDUSTRY_GROUP,
      label: 'Versicherungsgesellschaften',
    },
    {
      value: AGENCIES_BROKERAGES_INDUSTRY_GROUP,
      label: 'Versicherungsagenturen, -makler und sonstige versicherungsbezogene Tätigkeiten',
    },
  ],
  [FUNDS_TRUSTS_SUB_SECTOR]: [
    {
      value: INSURANCE_FUNDS_INDUSTRY_GROUP,
      label: 'Versicherungs- und Versorgungsfonds',
    },
    {
      value: OTHER_FUNDS_FUNDS_INDUSTRY_GROUP,
      label: 'Sonstige Investmentpools und -fonds',
    },
  ],
  [REAL_ESTATE_SUB_SECTOR]: [
    {
      value: LESSORS_OF_REAL_ESTATE_INDUSTRY_GROUP,
      label: 'Vermietung und Verpachtung von Grundstücken und Immobilien',
    },
    {
      value: OFFICES_OF_REAL_ESTATE_INDUSTRY_GROUP,
      label: 'Immobilienmakler- und -agenturbüros',
    },
    {
      value: ACTIVITIES_RELATED_TO_REAL_ESTATE_INDUSTRY_GROUP,
      label: 'Mit der Immobilienwirtschaft verbundene Tätigkeiten',
    },
  ],
  [RENTAL_AND_LEASING_SUB_SECTOR]: [
    {
      value: AUTOMOTIVE_LEASING_INDUSTRY_GROUP,
      label: 'Vermietung und Leasing von Kraftfahrzeugen',
    },
    {
      value: CONSUMER_GOODS_RENTAL_INDUSTRY_GROUP,
      label: 'Vermietung von Konsumgütern',
    },
    {
      value: GENERAL_RENTAL_CENTERS_INDUSTRY_GROUP,
      label: 'Allgemeine Vermietungszentren',
    },
    {
      value: COMMERCIAL_MACHINERY_INDUSTRY_GROUP,
      label: 'Vermietung und Leasing von gewerblichen und industriellen Maschinen und Geräten',
    },
  ],
  [LESSORS_OF_NONFINACIAL_ASSETS_SUB_SECTOR]: [],
  [SCIENTIFIC_SERVICES_SECTOR]: [
    {
      value: LEGAL_SERVICES_INDUSTRY_GROUP,
      label: 'Rechtsdienstleistungen',
    },
    {
      value: ACCOUNTING_SERVICES_INDUSTRY_GROUP,
      label: 'Dienstleistungen in den Bereichen Rechnungslegung, Steuerberatung, Buchführung und Lohnabrechnung',
    },
    {
      value: ARCHITECTURAL_SERVICES_INDUSTRY_GROUP,
      label: 'Architektur-, Ingenieur- und damit verbundene Dienstleistungen',
    },
    {
      value: DESIGN_SERVICES_INDUSTRY_GROUP,
      label: 'Spezialisierte Design-Dienstleistungen',
    },
    {
      value: COMPUTER_SYSTEMS_DESIGN_SERVICES_INDUSTRY_GROUP,
      label: 'Entwicklung von Computersystemen und damit verbundene Dienstleistungen',
    },
    {
      value: TECHNICAL_CONSULTING_SERVICES_INDUSTRY_GROUP,
      label: 'Unternehmens-, Wissenschafts- und technische Beratung',
    },
    {
      value: SCIENTIFIC_RESEARCH_SERVICES_INDUSTRY_GROUP,
      label: 'Forschung und experimentelle Entwicklung (F&E)',
    },
    {
      value: ADVERTISING_SERVICES_INDUSTRY_GROUP,
      label: 'Werbung, Öffentlichkeitsarbeit und damit verbundene Dienstleistungen',
    },
    {
      value: OTHER_TECHNICAL_SERVICES_INDUSTRY_GROUP,
      label: 'Sonstige freiberufliche, wissenschaftliche und technische Dienstleistungen',
    },
  ],
  [ADMINISTRATIVE_SERVICE_SUB_SECTOR]: [
    {
      value: OFFICE_ADMINISTRATIVE_SERVICES_INDUSTRY_GROUP,
      label: 'Büro- und Verwaltungsdienstleistungen',
    },
    {
      value: FACILITIES_SUPPORT_SERVICES_INDUSTRY_GROUP,
      label: 'Infrastrukturdienstleistungen für Gebäude und Anlagen',
    },
    {
      value: EMPLOYMENTS_SERVICES_INDUSTRY_GROUP,
      label: 'Arbeitsvermittlungs- und Personaldienstleistungen',
    },
    {
      value: BUSINESS_SUPPORT_SERVICES_INDUSTRY_GROUP,
      label: 'Unternehmensunterstützungsdienste',
    },
    {
      value: RESERVATION_SERVICES_INDUSTRY_GROUP,
      label: 'Reisebüros und Reservierungsdienstleistungen',
    },
    {
      value: INVESTIGATION_AND_SECURITY_SERVICES_INDUSTRY_GROUP,
      label: 'Ermittlungs- und Sicherheitsdienste',
    },
    {
      value: SERVICES_TO_BUILDINGS_INDUSTRY_GROUP,
      label: 'Gebäude- und Hausmeisterdienste',
    },
    {
      value: OTHER_SUPPORT_SERVICES_INDUSTRY_GROUP,
      label: 'Sonstige Unterstützungsdienste',
    },
  ],
  [WASTE_MANAGEMENT_SUB_SECTOR]: [
    {
      value: WASTE_COLLECTION_INDUSTRY_GROUP,
      label: 'Abfallsammlung',
    },
    {
      value: WASTE_DISPOSAL_INDUSTRY_GROUP,
      label: 'Abfallbehandlung und -beseitigung',
    },
    {
      value: REMEDIATION_AND_OTHER_WASTE_MANAGEMENT_SERVICE_INDUSTRY_GROUP,
      label: 'Sanierungs- und sonstige Abfallwirtschaftsdienste',
    },
  ],
  [EDUCATIONAL_SERVICES_SUB_SECTOR]: [
    {
      value: ELEMENTARY_SCHOOLS_INDUSTRY_GROUP,
      label: 'Grund- und Sekundarschulen',
    },
    {
      value: JUNIOR_COLLEGES_INDUSTRY_GROUP,
      label: 'Fach- und Juniorcolleges',
    },
    {
      value: PROFESSIONAL_SCHOOLS_INDUSTRY_GROUP,
      label: 'Hochschulen, Universitäten und berufliche Fachschulen',
    },
    {
      value: BUSINESS_SCHOOLS_INDUSTRY_GROUP,
      label: 'Wirtschaftsschulen sowie EDV- und Managementschulungen',
    },
    {
      value: TRADE_SCHOOLS_INDUSTRY_GROUP,
      label: 'Technische Fach- und Berufsschulen',
    },
    {
      value: OTHER_SCHOOLS_INDUSTRY_GROUP,
      label: 'Sonstige Schulen und Unterrichtsdienstleistungen',
    },
    {
      value: EDUCATIONAL_SUPPORT_SERVICES_INDUSTRY_GROUP,
      label: 'Sonstige Bildungsunterstützungsdienste',
    },
  ],
  [AMBULATORY_CARE_SUB_SECTOR]: [
    {
      value: PHYSICIANS_INDUSTRY_GROUP,
      label: 'Praxen von Ärzten',
    },
    {
      value: DENTISTS_INDUSTRY_GROUP,
      label: 'Zahnarztpraxen',
    },
    {
      value: OTHER_HEALTH_PRACTITIONERS_INDUSTRY_GROUP,
      label: 'Praxen sonstiger Gesundheitsdienstleister',
    },
    {
      value: OUTPATIENT_CARE_CENTERS_INDUSTRY_GROUP,
      label: 'Ambulante Versorgungszentren',
    },
    {
      value: MEDICAL_LABS_INDUSTRY_GROUP,
      label: 'Medizinische und diagnostische Labore',
    },
    {
      value: HOME_HEALTH_CARE_SERVICES_INDUSTRY_GROUP,
      label: 'Häusliche Krankenpflege',
    },
    {
      value: OTHER_AMBULATORY_HEALTH_CARE_INDUSTRY_GROUP,
      label: 'Sonstige ambulante Gesundheitsdienste',
    },
  ],
  [HOSPITALS_SUB_SECTOR]: [
    {
      value: GENERAL_MEDICAL_INDUSTRY_GROUP,
      label: 'Allgemeine medizinische und chirurgische Krankenhäuser',
    },
    {
      value: SUBSTANCE_ABUSE_HOSPITALS_INDUSTRY_GROUP,
      label: 'Psychiatrische Kliniken und Suchtkliniken',
    },
    {
      value: SPECIALTY_HOSPITALS__INDUSTRY_GROUP,
      label: 'Spezialkrankenhäuser (ohne Psychiatrie und Suchtkliniken)',
    },
  ],
  [NURSING_FACILITIES_SUB_SECTOR]: [
    {
      value: NURSING_CARE_FACILITIES_INDUSTRY_GROUP,
      label: 'Pflegeheime (stationäre Pflegeeinrichtungen)',
    },
    {
      value: RESIDENTIAL_INTELLECTUAL_INDUSTRY_GROUP,
      label: 'Wohnheime für Menschen mit geistiger Behinderung, psychischen Erkrankungen und Suchtproblemen',
    },
    {
      value: RETIREMENT_COMMUNITIES_INDUSTRY_GROUP,
      label: 'Altenwohnanlagen mit betreutem Wohnen und Pflege',
    },
    {
      value: OTHER_RESIDENTIAL_CARE_INDUSTRY_GROUP,
      label: 'Sonstige stationäre Betreuungseinrichtungen',
    },
  ],
  [SOCIAL_ASSISTANCE_SUB_SECTOR]: [
    {
      value: INDIVIDUAL_AND_FAMILY_SERVICES_INDUSTRY_GROUP,
      label: 'Hilfsdienste für Einzelpersonen und Familien',
    },
    {
      value: OTHER_RELIEF_SERVICES_INDUSTRY_GROUP,
      label: 'Gemeindenahe Angebote für Lebensmittel, Wohnraum sowie Not- und sonstige Hilfsdienste',
    },
    {
      value: VOCATIONAL_REHABILITATION_SERVICES_INDUSTRY_GROUP,
      label: 'Berufliche Rehabilitationsdienste',
    },
    {
      value: CHILD_CARE_SERVICES_INDUSTRY_GROUP,
      label: 'Kinderbetreuungsdienste',
    },
  ],
  [PERFORMING_ARTS_SUB_SECTOR]: [
    {
      value: PERFORMING_ARTS_COMPANIES_INDUSTRY_GROUP,
      label: 'Bühnen- und darstellende Kunstensembles',
    },
    {
      value: SPECTATOR_SPORTS_INDUSTRY_GROUP,
      label: 'Zuschauersportarten',
    },
    {
      value: PROMOTERS_OF_PERFORMING_ARTS_INDUSTRY_GROUP,
      label: 'Veranstalter von darstellender Kunst, Sport und ähnlichen Events',
    },
    {
      value: ARTISTS_AGENTS_AND_MANAGERS_INDUSTRY_GROUP,
      label: 'Agenturen und Manager für Künstler, Sportler, Entertainer und andere öffentliche Persönlichkeiten',
    },
    {
      value: INDEPENDENT_ARTISTS_INDUSTRY_GROUP,
      label: 'Freischaffende Künstler, Schriftsteller und Darsteller',
    },
  ],
  [MUSEUMS_SUB_SECTOR]: [],
  [AMUSEMENT_INDUSTRY_SUB_SECTOR]: [
    {
      value: AMUSEMENT_PARKS_INDUSTRY_GROUP,
      label: 'Freizeitparks und Spielhallen',
    },
    {
      value: GAMBLING_INDUSTRIES_INDUSTRY_GROUP,
      label: 'Glücksspielgewerbe',
    },
    {
      value: OTHER_AMUSEMENT_INDUSTRY_GROUP,
      label: 'Sonstige Freizeit- und Vergnügungsbetriebe',
    },
  ],
  [ACCOMMODATION_SUB_SECTOR]: [
    {
      value: TRAVELER_ACCOMMODATION_INDUSTRY_GROUP,
      label: 'Beherbergung von Reisenden',
    },
    {
      value: RECREATIONAL_CAMPS_INDUSTRY_GROUP,
      label: 'Campingplätze und Freizeitlager (einschließlich Stellplätze für Wohnmobile)',
    },
    {
      value: WORKERS_CAMPS_INDUSTRY_GROUP,
      label: 'Pensions-, Wohn- und Arbeiterunterkünfte sowie Wohnheime',
    },
  ],
  [FOOD_SERVICES_AND_DRINKING_PLACES_SUB_SECTOR]: [
    {
      value: SPECIAL_FOOD_SERVICES_INDUSTRY_GROUP,
      label: 'Sonstige Verpflegungsdienstleistungen (Catering u.Ä.)',
    },
    {
      value: DRINKING_PLACES_INDUSTRY_GROUP,
      label: 'Schankwirtschaften (alkoholische Getränke)',
    },
    {
      value: OTHER_EATING_PLACES_INDUSTRY_GROUP,
      label: 'Restaurants und sonstige Gaststätten',
    },
  ],
  [REPAIR_AND_MAINTENANCE_SUB_SECTOR]: [
    {
      value: AUTOMOTIVE_REPAIR_INDUSTRY_GROUP,
      label: 'Reparatur und Wartung von Kraftfahrzeugen',
    },
    {
      value: ELECTRONICS_REPAIR_INDUSTRY_GROUP,
      label: 'Reparatur und Wartung von Elektronik und Präzisionsgeräten',
    },
    {
      value: COMMERCIAL_REPAIR_AND_MAINTENANCE_INDUSTRY_GROUP,
      label:
        'Reparatur und Wartung gewerblicher und industrieller Maschinen und Ausrüstungen (ohne Kraftfahrzeuge und Elektronik)',
    },
    {
      value: PERSONAL_GOODS_REPAIR_INDUSTRY_GROUP,
      label: 'Reparatur und Wartung von privaten und Haushaltsgütern',
    },
  ],
  [LAUNDRY_SERVICE_SUB_SECTOR]: [
    {
      value: PERSONAL_CARE_SERVICES_INDUSTRY_GROUP,
      label: 'Dienstleistungen der Körperpflege',
    },
    {
      value: DEATH_CARE_SERVICES_INDUSTRY_GROUP,
      label: 'Bestattungsdienstleistungen',
    },
    {
      value: LAUNDRY_SERVICES_INDUSTRY_GROUP,
      label: 'Textilreinigung und Wäschereidienste',
    },
    {
      value: OTHER_PERSONAL_SERVICES_INDUSTRY_GROUP,
      label: 'Sonstige personenbezogene Dienstleistungen',
    },
  ],
  [RELIGIOUS_SUB_SECTOR]: [
    {
      value: RELIGIOUS_ORGANIZATIONS_INDUSTRY_GROUP,
      label: 'Religiöse Organisationen',
    },
    {
      value: GRANTMAKING_INDUSTRY_GROUP,
      label: 'Stiftungen und Vergabestellen für Fördermittel',
    },
    {
      value: SOCIAL_ADVOCACY_INDUSTRY_GROUP,
      label: 'Organisationen für gesellschaftliche Interessenvertretung',
    },
    {
      value: SOCIAL_ORGANIZATIONS_INDUSTRY_GROUP,
      label: 'Bürger- und Sozialvereinigungen',
    },
    {
      value: BUSINESS_LABOR_POLITICAL_INDUSTRY_GROUP,
      label: 'Wirtschafts-, Berufs-, Arbeitnehmer-, politische und ähnliche Verbände',
    },
  ],
  [ADMINISTRATION_OF_HOUSING_PROGRAMS_SUB_SECTOR]: [],
  [PRIVATE_HOUSEHOLDS_SUB_SECTOR]: [],
  [EXECUTIVE_LEGISLATIVE_SUB_SECTOR]: [],
  [JUSTICE_PUBLIC_ORDER_SUB_SECTOR]: [],
  [ADMINISTRATION_OF_HUMAN_RESOURCE_SUB_SECTOR]: [],
  [ADMINISTRATION_OF_ENVIRONMENTAL_QUALITY_SUB_SECTOR]: [],
  [ADMINISTRATION_OF_ECONOMIC_PROGRAMS_SUB_SECTOR]: [],
  [SPACE_RESEARCH_SUB_SECTOR]: [],
  [NATIONAL_SECURITY_SUB_SECTOR]: [],
  [MANAGEMENT_OF_COMPANIES_SECTOR]: [],
};
